import * as React from 'react';

// UTILS
import { queryStringToObject } from '../../utils';

// PACKAGES
import { useLocation } from 'react-router-dom';

// COMPONENTS
import AccountForm from './AccountForm';
import CheckEmail from './CheckEmail';

// TYPES
import { AccountRegistrationCommand, DomainProfileType } from '../../api/models';

export interface UserInfoType {
	email?: string;
	parentEmail?: string;
	organisationIdentifier?: AccountRegistrationCommand['organisationIdentifier'];
	paymentPlanId?: AccountRegistrationCommand['paymentPlanId'];
	profileType?: DomainProfileType;
}

interface CreateAccountTypes {}

export const CreateAccount: React.FC<CreateAccountTypes> = ({}) => {
	const location = useLocation();

	const [returnUrl, setReturnUrl] = React.useState<string>('');
	const [previousUrl, setPreviousUrl] = React.useState<string>('');

	const [userInfo, setUserInfo] = React.useState<UserInfoType>({
		email: '',
		parentEmail: '',
		organisationIdentifier: '',
		paymentPlanId: undefined,
		profileType: undefined
	});

	const checkLocationParams = () => {
		const locationParams = location.state;
		const queryParams = queryStringToObject();
		const params = { ...locationParams, ...queryParams };

		if (params.previousUrl) {
			setPreviousUrl(params.previousUrl);
		}

		if (params.returnUrl) {
			setReturnUrl(params.returnUrl);
		}

		if (params.organisationIdentifier || params.paymentPlanId || params.profileType) {
			setReturnUrl(params.returnUrl);

			setUserInfo({
				...userInfo,
				organisationIdentifier: params.organisationIdentifier || '',
				paymentPlanId: params.paymentPlanId || undefined,
				profileType: params.profileType || undefined
			});
		}
	};

	React.useEffect(() => {
		checkLocationParams();
	}, []);

	return (
		<div className="page-create-account">
			{!userInfo.email ? (
				<AccountForm userInfo={userInfo} setUserInfo={setUserInfo} returnUrl={returnUrl} previousUrl={previousUrl} />
			) : (
				<CheckEmail userInfo={userInfo} />
			)}
		</div>
	);
};

export default CreateAccount;
